import { render, staticRenderFns } from "./BookingReportView.vue?vue&type=template&id=4d4fa832&scoped=true&"
import script from "./BookingReportView.vue?vue&type=script&lang=js&"
export * from "./BookingReportView.vue?vue&type=script&lang=js&"
import style0 from "./BookingReportView.vue?vue&type=style&index=0&id=4d4fa832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4fa832",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4fa832')) {
      api.createRecord('4d4fa832', component.options)
    } else {
      api.reload('4d4fa832', component.options)
    }
    module.hot.accept("./BookingReportView.vue?vue&type=template&id=4d4fa832&scoped=true&", function () {
      api.rerender('4d4fa832', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingReportView.vue"
export default component.exports